// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"a845f861","238":"e95cf40f","645":"72b57af9"}[chunkId] + ".chunk.js";
};